import { ReplyChangeService } from '../../../services/reply-change.service';
import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { FundraiserService } from '../../../services/fundraiser.service';
import { MatDialog } from '@angular/material/dialog';
import { DonorListFullComponent } from '../donor-list-full/donor-list-full.component';
import { MediaObserver } from '@angular/flex-layout';
import { ThankDonarComponent } from 'src/app/shared/components/thank-donar/thank-donar.component';
import { ScrollStrategy } from '@angular/cdk/overlay';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Router } from '@angular/router';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AddOfflineDonationComponent } from '../../dialogs/offline-donations/add-offline-donation/add-offline-donation.component';
import { ViewSummaryComponent } from '../../dialogs/offline-donations/view-summary/view-summary.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor, NgClass, NgStyle, CurrencyPipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { UserIconComponent } from 'src/app/shared/components/user-icon/user-icon.component';

@Component({
    selector: 'app-donor-list-short',
    templateUrl: './donor-list-short.component.html',
    standalone: true,
    imports: [NgIf, FlexModule, MatSlideToggleModule, FormsModule, MatTooltipModule, MatButtonModule, NgFor, MatCardModule, NgClass, ExtendedModule, NgStyle, MatIconModule, MatProgressSpinnerModule, CurrencyPipe, MatTabsModule, UserIconComponent]
})
/** *Donor List Short Component */
export class DonorListShortComponent implements OnInit {
	@Input() isLoggedInUserAdmin: boolean = false;
	@Input() currentFundraiserID: string | any;
	@Input() donationReceivedBoolean!: boolean;
	@Input() hideToggleSwitch = false;
	@Input() donorShortData: any;
	@Input() isLoggedIn: any;
	@Input() currentFundraiser: any;
	@Input() isDraftOrClosed: boolean = false;
	@Input() isWholePreview!: boolean;
	@Output() updateDonorData = new EventEmitter<void>();

	slug: any;
	isDonorListLoading: boolean = true;
	donorData: any;
	scrollStrategy: ScrollStrategy | any;
	donarDataSlice: any;
	lang: any;
	count: any;
	showDonorList: boolean = true; // default value of toggle
	http: any;
	tooltip = $localize`:@@donor_list_hide_tooltip: Turn the toggle off to hide donation details on the public fundraiser page`;
	offlineDonationTooltip = $localize`:@@donor_list_offlinedonation_tooltip: This will allow you to add donation collected offline by the cause`;
	viewSummaryTooltip = $localize`:@@donor_list_view_summary_tooltip: Add offline donations to see summary`;
	addOfflineDonationTooltip = $localize`:@@donor_list_add_offline_donation_tooltip: Publish your fundraiser before adding offline donation`;
	totalOfflineDonationAmount: any;
	offlineDonationCount: any;
	isViewSummary: boolean = true;
	currency_symbol: any;
	donor = {};
	topContributors: any;
	page: number = 1;

	label_donorList_tab1 = $localize`:@@donor_list_tab1_label: Recent Donations`;
	label_donorList_tab2 = $localize`:@@donor_list_tab2_label: Top Contributors`;

	constructor(
		public fundraiserService: FundraiserService,
		public _media: MediaObserver,
		public dialog: MatDialog,
		public replyService: ReplyChangeService,
		private readonly cd: ChangeDetectorRef,
		public _accountService: AccountService,
		public router: Router,
		public notificationService: NotificationService,
		public fundRaiserService: FundraiserService
	) {}

	ngOnInit(): void {
		this.showDonorList = this.donationReceivedBoolean;
		this.slug = this.router.url.split('?')[0].substring(13);
		this.slug = this.fundRaiserService.getCurrentFundraiserSlug();

		this.replyService.changeUserValue(this.isLoggedInUserAdmin);
		this.lang = this._accountService.getLocaleId();
		this.isDonorListLoading = false;
		this.donorData = this.donorShortData?.data?.result?.result;
		this.count = this.donorShortData?.data?.result?.count;
		this.getOfflineDonations();
		this.fundraiserService.getOfflineDonation().subscribe((res) => {
			this.getOfflineDonations();
		});

		this.getTopContributors();
	}
	getInitial(name: string): string {
		if (!name) {
			return 'AN'; // If no name provided, return 'AN'
		}

		const nameParts = name.trim().split(' ');

		if (nameParts.length === 1) {
			// Single name: return first two initials of the first name
			return nameParts[0].substring(0, 2).toUpperCase();
		} else if (nameParts.length >= 2) {
			// Full name: return initials of first and last name
			const firstInitial = nameParts[0].charAt(0).toUpperCase();
			const lastInitial = nameParts[nameParts.length - 1]
				.charAt(0)
				.toUpperCase();
			return `${firstInitial}${lastInitial}`;
		}

		return 'AN'; // Fallback condition
	}
	/** *View Donor List Full Component */
	viewFullDonorList() {
		this.dialog.open(DonorListFullComponent, {
			panelClass: 'max-w-100--panelClass',
			maxHeight: '95vh',
			width: '100vh',
			data: {
				isLoggedInUserAdmin: this.isLoggedInUserAdmin,
			},
		});
	}

	addOfflineDonation(): void {
		this.dialog.open(AddOfflineDonationComponent, {
			maxHeight: '98vh',
			data: {
				slug: this.slug,
				currency_symbol: this.currentFundraiser.currency_symbol,
				currency_code: this.currentFundraiser.currency_code,
			},
		});
	}

	// Function to open a dialog for viewing offline donation summary
	viewOfflineDonationSummary(): void {
		this.dialog.open(ViewSummaryComponent, {
			data: {
				slug: this.slug, // Pass the fundraiser slug
				isLoggedIn: this.isLoggedIn, // Pass the login status
				isLoggedInUserAdmin: this.isLoggedInUserAdmin, // Pass the admin status
			},
		});
	}

	// Function to fetch all offline donations for the fundraiser
	getOfflineDonations() {
		const slug = this.slug;
		if (slug) {
			this.fundraiserService
				.getAllOfflineDonation(this.slug)
				.subscribe((res: any) => {
					// Update the total offline donation amount
					this.totalOfflineDonationAmount = Number(
						res.data.result.total_amount
					);
					// Update the currency symbol
					this.currency_symbol = this.currentFundraiser.currency_symbol;
					// Update the count of offline donations
					this.offlineDonationCount = res.data.result.details.length;
					// Determine if the summary view should be shown
					this.isViewSummary = this.offlineDonationCount !== 0;
				});
		}
	}

	// Function to open a dialog for thanking a donor
	openDialog(index: any): void {
		const dialogRef = this.dialog.open(ThankDonarComponent, {
			width: '80vh',
			maxHeight: '98vh',
			data: { count: this.donorData[index] }, // Pass the donor data to the dialog
		});

		dialogRef.componentInstance.replyPosted.subscribe(() => {
			this.updateDonorData.emit();
		});
	}

	/**
	 * Function responsible for toggling between hide and show donor list
	 * @param event - MatSlideToggleChange event
	 */
	onToggleChange(event: MatSlideToggleChange) {
		this.showDonorList = event.checked; // Update the showDonorList property based on toggle state
		const toggleValue = { show_donor_list: this.showDonorList };

		// Check if headers are valid before making the service call
		if (this._accountService.checkHeaders()) {
			this.fundraiserService
				.showDonationList({
					show_donations: this.showDonorList,
					slug: this.slug,
				})
				.subscribe((res) => {
					// Notify the user about the change
					this.notificationService.openNotification(
						$localize`:@@donor_list_hidden_change_notification: Donor list details change is saved`,
						'',
						'success'
					);
					// Reload the window to reflect changes
					window.location.reload();
				},
				(error) => {
				  this.notificationService.openNotification(
					$localize`:@@donor_list_hidden_change_error:An error occurred while saving donor list details`,
					'',
					'error'
				  );
				});
		}
	}

	/**
	 * Fetches the top contributors for the current fundraiser campaign and updates the component state.
	 */
	getTopContributors() {
		// Invoke the service method to fetch top contributors
		this.fundRaiserService.getTopContributors(this.slug, this.lang, this.page).subscribe({
			// Handle successful response
			next: (res: any) => {
				// Extract the contributors' data from the response
				this.topContributors = res?.data?.result;
			},
			// Handle errors during the API call
			error: (error: any) => {
				// Log the error for debugging
				console.error('Error fetching top contributors:', error);
			},
		});
	}
}
